import React from "react";
import { ProductWarranteeFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";
import { userService } from "apiServices";

const ProductWarranteeForm = ({ onSubmit }) => {
  const schema = yup.object().shape({
    image_file: yup
      .array()
      .required("Receipt is required")
      .min(1, "Receipt is required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { t, i18n } = useTranslation(["common", "form"]);

  return (
    <ProductWarranteeFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.UploadMultiApi
                {...field}
                maxMBFileSizeWarning={8}
                acceptType="cover"
                uploadApiUrl={userService.POST_PRODUCT_WARRANRY_UPLOAD}
                errors={errors.image_file?.message}
              />
            )}
            name="image_file"
            defaultValue={[]}
          />
        </div>
        <div className="input_wrap mb_32">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                theme_placeholder_light
                placeholder={t("Type the store name", { ns: "form" })}
                errors={errors.store_name?.message}
              />
            )}
            name="store_name"
          />
        </div>
        <div className="btn_submit_wrap">
          <Buttons.BgStandard
            label={
              i18n.language === "en"
                ? "Product Registration"
                : "ลงทะเบียนสินค้า"
            }
            type="submit"
          />
        </div>
      </form>
    </ProductWarranteeFormStyled>
  );
};

ProductWarranteeForm.propTypes = {};

export default ProductWarranteeForm;
